import {STOCKTAKE_SORT_OPTIONS} from '../../common/constants/Stocktakes.js'
import Sort from '../../common/components/List/Sort.js'
import {setSort, stocktakeListQuerySelector} from './stocktakeListFunctions.js'
import {useSelector} from '../../store.js'

export default function StocktakeSort() {
  const sort = useSelector(stocktakeListQuerySelector).sort

  return (
    <Sort
      items={STOCKTAKE_SORT_OPTIONS}
      value={sort}
      onChange={(value) => setSort(value)}
    />
  )
}
